import React from 'react'
import { Button, Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import { CallToActionCard } from '../components'
import { contactPlaceholderCard } from '../components/CallToActionCards/components/ContactPlaceholderCardImage'
import { CarouselCardImages } from '../components/CallToActionCards/components/CarouselCardImages'
import { useActions, useSelector, useState } from 'src/hooks'
import { HeartfeltPathDialog } from '../components/CallToActionCards/components/HeartfeltPathDialog'
import { SystemPathDialog } from '../components/CallToActionCards/components/SystemPathDialog'

export const ActionItemSection = () => {
  const [
    shouldShowHeartfeltPathModal,
    setShouldShowHeartfeltPathModal,
  ] = useState(false)
  const [shouldShowSystemPathModal, setShouldShowSystemPathModal] = useState(
    false,
  )
  const actions = useActions()

  const isMobile = useSelector(state => state.window.isMobile)
  const heartfeltCardItems = [
    {
      cardId: '3675084',
      previewUrl:
        'https://www.sendoutcards.com/thumbnail/U3x7H-sVb_UNjY_9c9JWfeQl4l0=/fit-in/700x0/system_images/2022/2/10/25c3e25a-4c00-480c-b791-0d979e5822dd.png',
      isHorizontal: false,
      rotation: -8,
    },
    {
      cardId: '',
      previewUrl:
        'https://images.unsplash.com/photo-1542596594-649edbc13630?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
      isHorizontal: false,
      rotation: 8,
    },
    {
      cardId: '3671600',
      previewUrl:
        'https://www.sendoutcards.com/thumbnail/FWdijC4BNRkVZEb7aYe8ZBw4yI8=/fit-in/700x0/system_images/2019/12/4/89c847ed-658f-421b-a351-12a7848dcd32.png',
      isHorizontal: false,
      rotation: 8,
    },
  ]
  const systemCardItems = [
    {
      cardId: '3674714',
      previewUrl:
        'https://www.sendoutcards.com/thumbnail/MTHGRgmTPLlmKPdL87JWdwbUtbA=/fit-in/700x0/system_images/2020/12/2/1f362ae5-482d-4963-b2cb-c8d635666bae.png',
      isHorizontal: false,
    },
    {
      cardId: '3675646',
      previewUrl:
        'https://www.sendoutcards.com/thumbnail/ICBMoQjQvdWPXyoGdvVt79t7GHg=/fit-in/700x0/system_images/2023/5/2/937ef6e8-52d7-41bb-83ea-fae84a3c8395.png',
      isHorizontal: false,
    },
    {
      cardId: '3673616',
      previewUrl:
        'https://www.sendoutcards.com/thumbnail/2WXPXFvTq8vjo-I3nAWibpOyt_w=/fit-in/700x0/system_images/2019/12/4/108e8383-8ae0-4475-a67e-7f92dddd48e2.png',
      isHorizontal: false,
    },
  ]

  return (
    <Flex flexDirection={'column'} width="100%">
      <Text
        type="largeBody"
        weight="bold"
        color="primaryHeading"
        content="Heartfelt Prompting Cards"
        style={{ letterSpacing: '.3px', marginLeft: 4 }}
      />
      <Spacer space="x2_5" />
      <CallToActionCard
        isStacked={isMobile}
        theme="light"
        tag={{
          icon: 'heartfelt',
          iconColor: 'pink',
          title: "Brighten Someone's Day!",
        }}
        title="Heartfelt Card Sending"
        caption="Reach out and share kindness with someone you know today!"
        actions={
          <Button
            title="Send a Card"
            onClick={() => setShouldShowHeartfeltPathModal(true)}
            backgroundColorOverride={'#BE9CDD'}
            size="small"
          />
        }
        graphicBackground={{ image: '', color: '#BE9CDD' }}
        graphic={
          <CarouselCardImages
            cardHeight="225px"
            cardWidth="155px"
            gap="24px"
            cardRadius={12}
            cards={heartfeltCardItems}
          />
        }
      />
      <Spacer space="x4" />
      <Text
        type="largeBody"
        weight="bold"
        color="primaryHeading"
        content="Follow-Up Tools"
        style={{ letterSpacing: '.3px', marginLeft: 4 }}
      />
      <Spacer space="x2" />
      <Flex style={{ gap: '24px' }} flexDirection={isMobile ? 'column' : 'row'}>
        <CallToActionCard
          maxWidth="350px"
          theme="light"
          tag={{
            icon: 'heartfelt',
            iconColor: 'pink',
            title: 'Follow-Up & Campaigns',
          }}
          title="System Card Sending"
          titleSize="subtitle"
          caption="Follow-up, bulk cards, campaigns, and even schedule your cards ahead of time."
          graphicBackground={{ image: '', color: '#cdd0d5' }}
          graphic={
            <CarouselCardImages
              cardHeight="225px"
              cardWidth="155px"
              gap="24px"
              cardRadius={12}
              cards={systemCardItems}
            />
          }
          graphicOrder={2}
          isStacked={true}
          onClick={() => setShouldShowSystemPathModal(true)}
        />
        <CallToActionCard
          onClick={() => actions.openRelationshipManager()}
          maxWidth="350px"
          theme="light"
          tag={{
            icon: 'heartfelt',
            iconColor: 'pink',
            title: 'Build Connections',
          }}
          title="Manage Your Contacts"
          titleSize="subtitle"
          caption="Utilize the contact management system to keep track of who you meet by adding birthdates, anniversary dates, notes, and more. Click here to view, edit, or send a card to one of your connections."
          graphicOrder={2}
          graphicBackground={{
            image:
              'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
            color: '',
          }}
          graphic={
            <Flex
              style={{ gap: 8 }}
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <img
                src={contactPlaceholderCard}
                alt="contactGraphic"
                style={{ width: '80%' }}
              />
              <img
                src={contactPlaceholderCard}
                alt="contactGraphic"
                style={{ width: '80%' }}
              />
              <img
                src={contactPlaceholderCard}
                alt="contactGraphic"
                style={{ width: '80%' }}
              />
            </Flex>
          }
          isStacked={true}
        />
      </Flex>
      <HeartfeltPathDialog
        cards={heartfeltCardItems}
        isOpen={shouldShowHeartfeltPathModal}
        onClose={() => setShouldShowHeartfeltPathModal(false)}
      />
      <SystemPathDialog
        cards={systemCardItems}
        isOpen={shouldShowSystemPathModal}
        onClose={() => setShouldShowSystemPathModal(false)}
      />
    </Flex>
  )
}
